/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { JimboResponse, Template } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const TemplateApi = createApi({
  reducerPath: 'TemplateApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Email', 'Sms'],
  endpoints: (builder) => ({
    getEmailTemplates: builder.query<Template, void>({
      query: () => `/templates/email`,
      providesTags: ['Email'],
      transformResponse: (response: JimboResponse<Template>) => response.data!,
    }),
    getSMSTemplates: builder.query<Template, void>({
      query: () => `/templates/sms`,
      providesTags: ['Sms'],
      transformResponse: (response: JimboResponse<Template>) => response.data!,
    }),
    updateEmailTemplate: builder.mutation<Template, Partial<Template>>({
      query: (template) => ({
        url: `/templates/email`,
        method: 'POST',
        body: template,
      }),
      transformResponse: (response: JimboResponse<Template>) => response.data!,
      invalidatesTags: ['Email'],
    }),

    updateSMSTemplate: builder.mutation<Template, Partial<Template>>({
      query: (template) => ({
        url: `/templates/sms`,
        method: 'POST',
        body: template,
      }),
      transformResponse: (response: JimboResponse<Template>) => response.data!,
      invalidatesTags: ['Sms'],
    }),
  }),
});

export const { useGetEmailTemplatesQuery, useGetSMSTemplatesQuery, useUpdateEmailTemplateMutation, useUpdateSMSTemplateMutation } =
  TemplateApi;
